import { Step } from "react-joyride";

export const tourStepsFullScreenDisplay = (): Step[] => {
  const steps: Step[] = [
    {
      target: ".fullscreen-display",
      content:
        "This is a practice session. Items appear one at a time at the speed you chose. When it ends, you will see a short session report.",
      disableBeacon: true,
    },
    {
      target: ".session-controls",
      content:
        "Back leaves without saving a report. Pause stops the auto-advance until you resume.",
    },
    {
      target: ".pause-button",
      content: "Use Pause if you need a moment, then Resume to continue.",
    },
    {
      target: ".previous-button",
      content:
        "In auto-play, the arrows let you go back or forward without waiting for the timer.",
    },
    {
      target: ".next-button",
      content: "Next moves to the following item.",
    },
    {
      target: ".progress-indicator",
      content:
        "The bar shows how far you are through the collection. Gold means you reached the end.",
    },
    {
      target: ".interactive-answer",
      content:
        "In interactive mode, type the answer and submit. Wrong answers count as missed. Skip moves on and counts as skipped.",
    },
    {
      target: ".skip-button",
      content:
        "Skip this item if a student is stuck. Skipped items show up on the session report and on Reports.",
    },
  ];

  return steps;
};
